// src/data/mockUserData.js
// export const firstNames = [ "Anil","Ravi","Pooja","Priya","Deepa","Karthik","Subham","Jignesh","Lakshmi","Ramesh",
//   "Sunita","Vijay","Neha","Yash","Komal","Madhavi","Soma","Dipika","Manoj","Bikash",
//   "Vishnu","Shanthi","Ketan","Hetal","Rekha","Madhavi","Ananya","Debashish","Kalpesh","Bhavana",
//   "Divya","Suresh","Meena","Chetan","Ritu","Rupal","Yash","Subham","Ravi","Anand",
//   "Deepa","Lakshmi","Pooja","Sunita","Vijay","Neha","Priya","Anil","Komal","Jignesh",
//   "Ramesh","Madhavi","Soma","Dipika","Bikash","Manoj","Vishnu","Shanthi","Ketan","Hetal","Bhavya", "Bhumika", "Chaitanya", "Daksh", "Dev",
//   "Eeshaan", "Gaurang", "Harsh", "Ishaan", "Jai",
//   "Jiya", "Karan", "Ananta", "Aruna", "Bala",
//   "Chanda", "Isha", "Kamala", "Kanti", "Mitra",
//   "Padma", "Radha", "Shakti", "Sushila", "Vijaya",
//   "Aahaana", "Aaloka", "Aamani", "Aanchal", "Aaravi",
//   "Aashi", "Aayushi", "Adriti", "Advika", "Aaditya",
//   "Anika", "Arya", "Bhavini", "Chaya", "Diya",
//   "Eesha", "Lavanya", "Manasi", "Nishi", "Prachi",
//   "Riya", "Saanvi", "Tara", "Vedika", "Yashi",
//   "Anahath", "Anchala", "Bhadrashree", "Bhavisha", "Bhawna",
//   "Chaah", "Darsha", "Devanya", "Devi Priya", "Himaanshu",
//   "Jiya Ram", "Kaanchana", "Kanahiya", "Kiansh", "Maadhav",
//   "Navami", "Neeraj Nayan", "Neevetha", "Premanand", "Raadha",
//   "Ravit", "Ripu", "Risha", "Sadhika", "Samvid",
//   "Sarveshwar", "Shubh", "Venkatesh", "Vimad", "Vinamr",
//   "Aravind", "Shashank", "Advait", "Devesh", "Keyur",
//   "Krishiv", "Darsh", "Rishaan", "Asuman", "Madhav",
//   "Aabha", "Aabharana", "Aabhas", "Aabhat", "Adwita",
//   "Aswini", "Chitra", "Dheerkhabaahu", "Geethika", "Hetveer",
//   "Sharmila", "Ishaanvi", "Jasvitha", "Kavya", "Lakshita", ];
  export const maleNames = [
  "Anil", "Ravi", "Karthik", "Subham", "Jignesh", "Ramesh",
  "Vijay", "Yash", "Manoj", "Bikash", "Vishnu", "Ketan",
  "Kalpesh", "Suresh", "Chetan", "Anand", "Maadhav", "Dev",
  "Daksh", "Eeshaan", "Gaurang", "Harsh", "Ishaan", "Jai",
  "Karan", "Chaitanya", "Bala", "Himaanshu", "Kiansh", "Premanand",
  "Neeraj Nayan", "Ravit", "Ripu", "Sarveshwar", "Shubh",
  "Venkatesh", "Vimad", "Vinamr", "Aravind", "Shashank",
  "Advait", "Devesh", "Keyur", "Krishiv", "Darsh", "Rishaan",
  "Asuman", "Madhav", "Aabhas", "Aabhat", "Hetveer",

  // Newly added male names
  "Aarush", "Vivaan", "Reyansh", "Ivaan", "Shaurya",
  "Kunal", "Ritvik", "Armaan", "Tejas", "Omkar",
  "Hridaan", "Samar", "Tanish", "Ayan", "Ranveer",
  "Kabir", "Atharv", "Nivaan", "Yug", "Harshit"
];
export const femaleNames = [
  "Pooja", "Priya", "Deepa", "Lakshmi", "Sunita", "Neha",
  "Komal", "Madhavi", "Soma", "Dipika", "Hetal", "Bhavana",
  "Divya", "Meena", "Ritu", "Rupal", "Rekha", "Ananya",
  "Bhavya", "Bhumika", "Jiya", "Aruna", "Chanda", "Isha",
  "Kamala", "Kanti", "Mitra", "Padma", "Radha", "Shakti",
  "Sushila", "Vijaya", "Aahaana", "Aaloka", "Aamani", "Aanchal",
  "Aaravi", "Aashi", "Aayushi", "Adriti", "Advika", "Anika",
  "Arya", "Bhavini", "Chaya", "Diya", "Eesha", "Lavanya",
  "Manasi", "Nishi", "Prachi", "Riya", "Saanvi", "Tara",
  "Vedika", "Yashi", "Anchala", "Bhadrashree", "Bhavisha",
  "Bhawna", "Chaah", "Darsha", "Devanya", "Devi Priya",
  "Jiya Ram", "Kaanchana", "Neevetha", "Raadha", "Risha",
  "Sadhika", "Samvid", "Aabha", "Aabharana", "Adwita",
  "Aswini", "Chitra", "Geethika", "Sharmila", "Ishaanvi",
  "Jasvitha", "Kavya", "Lakshita",

  // Newly added female names
  "Myra", "Kashvi", "Keya", "Riddhi", "Aaradhya",
  "Mahika", "Tanisha", "Vaidehi", "Nayra", "Anvi",
  "Trisha", "Ira", "Shanaya", "Diara", "Navya",
  "Saloni", "Meera", "Prisha", "Sitara", "Vanya"
];

export const lastNames = [
  "Kumar", "Singh", "Sharma", "Patel", "Verma", "Gupta",
  "Yadav", "Rana", "Thakur", "Mishra", "Tripathi", "Shukla",
  "Tiwari", "Jha", "Pandey", "Choudhary", "Chauhan", "Rathi",
  "Dubey", "Pathak", "Saxena", "Srivastava", "Agarwal", "Saini",
  "Rawat", "Bhatt", "Dwivedi", "Nigam", "Rastogi", "Bhardwaj",
  "Kapoor", "Khanna", "Malhotra", "Bansal", "Goel", "Mehra",
  "Mittal", "Arora", "Sethi", "Goyal", "Chhabra", "Batra",
  "Nagpal", "Nanda", "Sabharwal", "Talwar", "Kohli", "Vohra",
  "Mahajan", "Sodhi", "Gulati", "Garg", "Raina", "Khatri",
  "Bedi", "Chopra", "Grover", "Juneja", "Vig", "Duggal",
  "Sachdeva", "Manchanda", "Ahuja", "Chaddha", "Sarin", "Oberoi",
  "Behl", "Kansal", "Nagori", "Narang", "Madaan", "Aggarwal",
  "Rathi", "Lohia", "Baranwal", "Bagga", "Rastogi", "Bhargava",
  "Paliwal", "Trivedi", "Upadhyay", "Nayak", "Bhardwaj", "Joshi",
  "Acharya", "Bhattacharya", "Chatterjee", "Banerjee", "Mukherjee",
  "Ghosh", "Dutta", "Sengupta", "Roy", "Bose", "Chakraborty",
  "Das", "Sarkar", "Nandi", "Mazumdar", "Kanjilal", "Pal",
  "Raut", "Naik", "Shetty", "Pai", "Menon", "Nair",
  "Pillai", "Iyer", "Iyengar", "Rao", "Krishnan", "Subramanian",
  "Venkatesh", "Sundaram", "Murthy", "Ranganathan", "Ramachandran",
  "Balakrishnan", "Gopalakrishnan", "Chandrasekhar", "Ananth",
  "Lakshmanan", "Jayaram", "Venugopal", "Srinivasan", "Narayanan",
  "Madhavan", "Rajagopalan", "Jagannathan", "Narasimhan", "Varadarajan",
  "Kannan", "Muthuswamy", "Devarajan", "Perumal", "Radhakrishnan",
  "Saravanan", "Rajendran", "Duraisamy", "Selvaraj", "Vijayan",
  "Mani", "Arunachalam", "Sivakumar", "Ganesh", "Thirumalai",
  "Govindarajan", "Baskaran", "Sankaran", "Karthikeyan", "Chidambaram",
  "Thirunavukkarasu", "Velu", "Ilango", "Veerappan", "Sundaramoorthy",
  "Jayakumar", "Mohan", "Ramakrishnan", "Bhagwat", "Deshmukh",
  "Pawar", "Patil", "Phadke", "Kulkarni", "Desai", "Shinde",
  "Josalkar", "Nikam", "Bhide", "Ranade", "Naik", "Jadhav",
  "Waghmare", "Sawant", "Chavan", "Ambedkar", "Gavhane", "Bhosale",
  "Kadam", "Londhe", "Gite", "More", "Sapkal", "Raut",
  "Gite", "Kamble", "Lahane", "Ahir", "Mhatre", "Salunkhe",
  "Sathe", "Tambe", "Bhagat", "Chitale", "Gawande", "Kharat",
  "Khobragade", "Kale", "Mahale", "Wagh", "Bhoyar", "Gaikwad",
  "Lokhande", "Khare", "Hegde", "Udupa", "Kudva", "Ravindra",
  "Puthran", "Shenoy", "Shet", "Bhat", "Mallya", "Kamath",
  "Kotian", "Alva", "Nambiar", "Panicker", "Kurup", "Warrier",
  "Kunjir", "Kale", "Bhoskar", "Tiwary", "Mourya", "Rajput"
];

export const cities = [
  "Mumbai", "Delhi", "Pune", "Bangalore", "Sundergarh", "Hyderabad", "Kolkata",
  "Ahmedabad", "Chennai", "Jaipur", "Surat", "Lucknow", "Kanpur", "Nagpur", "Indore", "Thane", "Bhopal",
  "Visakhapatnam", "Patna", "Vadodara", "Ghaziabad", "Ludhiana", "Agra", "Nashik", "Faridabad",
  "Meerut", "Rajkot", "Kalyan", "Vasai-Virar", "Varanasi", "Srinagar", "Aurangabad", "Dhanbad",
  "Amritsar", "Navi Mumbai", "Allahabad", "Ranchi", "Howrah", "Jabalpur", "Gwalior", "Vijayawada",
  "Jodhpur", "Madurai", "Raipur", "Kota", "Guwahati", "Chandigarh", "Solapur", "Hubballi–Dharwad",
  "Mysuru", "Tiruchirappalli", "Bareilly", "Aligarh", "Moradabad", "Jalandhar", "Bhubaneswar",
  "Salem", "Warangal", "Guntur", "Bhiwandi", "Saharanpur", "Gorakhpur", "Bikaner", "Amravati",
  "Noida", "Jamshedpur", "Bhilai", "Cuttack", "Firozabad", "Kochi", "Nellore", "Bhavnagar",
  "Dehradun", "Durgapur", "Asansol", "Rourkela", "Nanded", "Kolhapur", "Ajmer", "Akola", "Gulbarga",
  "Jamnagar", "Ujjain", "Loni", "Siliguri", "Jhansi", "Ulhasnagar", "Nellore", "Jammu", "Sangli",
  "Belgaum", "Mangalore", "Ambattur", "Tirunelveli", "Malegaon", "Gaya", "Jalgaon", "Udaipur",
  "Maheshtala", "Tiruppur", "Davanagere", "Kozhikode", "Kurnool", "Rajpur Sonarpur", "Rajahmundry",
  "Bokaro Steel City", "South Dumdum", "Bellary", "Patiala", "Gopalpur", "Agartala", "Bhagalpur",
  "Muzaffarnagar", "Bhatpara", "Panihati", "Latur", "Dhule", "Rohtak", "Korba", "Bhilwara",
  "Berhampur", "Muzaffarpur", "Ahmednagar", "Mathura", "Kollam", "Avadi", "Kadapa", "Anantapur",
  "Kamarhati", "Bilaspur", "Sambalpur", "Shahjahanpur", "Satara", "Bijapur", "Rampur", "Shimoga",
  "Chandrapur", "Junagadh", "Thrissur", "Alwar", "Bardhaman", "Kulti", "Nizamabad", "Parbhani",
  "Tumkur", "Khammam", "Ozhukarai", "Bihar Sharif", "Panipat", "Darbhanga", "Bally", "Aizawl",
  "Dewas", "Ichalkaranji", "Karnal", "Bathinda", "Jalna", "Eluru", "Barasat", "Kirari Suleman Nagar",
  "Purnia", "Satna", "Mau", "Sonipat", "Farrukhabad", "Sagar", "Rourkela Industrial Township",
  "Durg", "Imphal", "Ratlam", "Hapur", "Arrah", "Anand", "Machilipatnam", "Raichur", "Nagercoil",
  "Etawah", "Bharatpur", "Begusarai", "New Delhi", "Chhapra", "Kadiri", "Bhind", "Malda", "Khandwa",
  "Dindigul", "Bhiwani", "Mandya", "Faizabad", "Tenali", "Buxar", "Navsari", "Tinsukia", "Yamunanagar",
  "Palghar", "Rewa", "Bettiah", "Bahraich", "Ambikapur", "Banda", "Kishanganj", "Katihar", "Bhavnagar",
  "Pali", "Rewari", "Bhavnagar", "Bhawanipatna", "Karaikal", "Itarsi", "Morena", "Pilibhit", "Baran",
  "Chhindwara", "Fatehpur", "Vellore", "Bhavinpur"
];

export const times = [
  "1 minute ago", "2 minutes ago", "3 minutes ago", "4 minutes ago", "5 minutes ago",
  "6 minutes ago", "7 minutes ago", "8 minutes ago", "9 minutes ago", "10 minutes ago",
  "11 minutes ago", "12 minutes ago", "13 minutes ago", "14 minutes ago", "15 minutes ago",
  "16 minutes ago", "17 minutes ago", "18 minutes ago", "19 minutes ago", "20 minutes ago",
  "21 minutes ago", "22 minutes ago", "23 minutes ago", "24 minutes ago", "25 minutes ago",
  "26 minutes ago", "27 minutes ago", "28 minutes ago", "29 minutes ago", "30 minutes ago",
  "31 minutes ago", "32 minutes ago", "33 minutes ago", "34 minutes ago", "35 minutes ago",
  "36 minutes ago", "37 minutes ago", "38 minutes ago", "39 minutes ago", "40 minutes ago",
  "41 minutes ago", "42 minutes ago", "43 minutes ago", "44 minutes ago", "45 minutes ago",
  "46 minutes ago", "47 minutes ago", "48 minutes ago", "49 minutes ago", "50 minutes ago",
  "51 minutes ago", "52 minutes ago", "53 minutes ago", "54 minutes ago", "55 minutes ago",
  "56 minutes ago", "57 minutes ago", "58 minutes ago", "59 minutes ago",
  
  "1 hour ago", "2 hours ago", "3 hours ago", "4 hours ago", "5 hours ago",
  "6 hours ago", "7 hours ago", "8 hours ago", "9 hours ago", "10 hours ago",
  "11 hours ago", "12 hours ago", "13 hours ago", "14 hours ago", "15 hours ago",
  "16 hours ago", "17 hours ago", "18 hours ago", "19 hours ago", "20 hours ago",
  "21 hours ago", "22 hours ago", "23 hours ago",
  
  "1 day ago", "1 day 1 hour ago", "1 day 2 hours ago", "1 day 3 hours ago",
  "1 day 4 hours ago", "1 day 5 hours ago", "1 day 6 hours ago", "1 day 7 hours ago",
  "1 day 8 hours ago", "1 day 9 hours ago", "1 day 10 hours ago", "1 day 11 hours ago",
  "1 day 12 hours ago", "1 day 13 hours ago", "1 day 14 hours ago", "1 day 15 hours ago",
  "1 day 16 hours ago", "1 day 17 hours ago", "1 day 18 hours ago", "1 day 19 hours ago",
  "1 day 20 hours ago", "1 day 21 hours ago", "1 day 22 hours ago", "1 day 23 hours ago",
  
  "2 days ago"
];
